import { RouteObject } from 'react-router-dom';
import {
  HomePage,
  AboutPage,
  ContactPage,
  SectorDetailPage,
  NotFoundPage,
  VisitingCardPage,
  CoffeePage
} from '../../pages';
import { ThemeConfig } from '../../pages/VisitingCardPage';
import { AppRouteConfig } from './types';

import infiniteLogo from '../../assets/theinfiniteorigin_logo.svg';
import sanoodPhoto from '../../assets/sanood_photo.png';
import nashwanPhoto from '../../assets/nashwan_photo.png';
import easyBuyLogo from '../../assets/logo.png';

// Contact Data configurations
const nashwanData = {
  name: 'Muhammad Nashwan',
  title: 'EasyBuy General Trading',
  phone: '+971582221672',
  email: 'nashwanpk@easybuytrd.com',
  website: 'https://easybuytrd.com',
  location: 'Easy Buy General Trading LLC, 79RX+WH5 - Al Qusais Ind. Fourth - Dubai',
  photoUrl: nashwanPhoto,
  logoUrl: easyBuyLogo
};

const sanoodData = {
  name: 'Sanood Abdulla CP',
  title: 'The Infinite Origin',
  phone: '+971589545619', // Placeholder
  email: 'sanood@theinfiniteorigin.com', // Placeholder
  website: 'https://theinfiniteorigin.com',
  location: 'DMCC Coffee Centre, Jabal Ali Industrial Second - Dubai',
  instagram: 'https://www.instagram.com/the_infiniteorigin_coffee?igsh=MXAyN3RzZmc4YnUxag==',
  photoUrl: sanoodPhoto,
  logoUrl: infiniteLogo
};

// Theme configurations
const easyBuyTheme: ThemeConfig = {
  primaryColor: '#FBA520', // Orange-500
  secondaryColor: '#FFF7ED', // Orange-50
  gradientStart: '#FB923C', // Orange-400
  gradientEnd: '#FBA520', // Orange-500
  buttonTextColor: '#EA580C', // Orange-600
};

const infiniteOriginTheme: ThemeConfig = {
  primaryColor: '#000000', // Black
  secondaryColor: '#F5F5F5', // Light Gray
  gradientStart: '#000000', // Black
  gradientEnd: '#333333', // Dark Gray
  buttonTextColor: '#000000', // Black text for secondary buttons/icons
  fontFamily: "Lora",
};

export const routes: AppRouteConfig[] = [
  // ... existing routes ...
  {
    path: '/',
    element: <HomePage />,
    title: 'EasyBuy General Trading - Global Trading Solutions',
    description: 'Leading supply chain management and global trading solutions across multiple sectors with over 20 years of experience.',
    keywords: ['supply chain', 'global trading', 'logistics', 'easybuy']
  },
  {
    path: '/coffee',
    element: <CoffeePage />,
    title: 'Ethiopian Coffee - EasyBuy General Trading',
    description: 'Discover our premium Ethiopian coffee, sourced from 22 wet mill stations and a network of over 22,600 farmers.',
    keywords: ['ethiopian coffee', 'sidama coffee', 'coffee beans', 'arabica']
  },
  {
    path: '/about',
    element: <AboutPage />,
    title: 'About Us - EasyBuy General Trading',
    description: 'Learn about EasyBuy General Trading\'s mission, values, and commitment to excellence in global supply chain management.',
    keywords: ['about easybuy', 'company history', 'supply chain expertise']
  },
  {
    path: '/sectors/:sectorId',
    element: <SectorDetailPage />,
    title: 'Sector Details - EasyBuy General Trading',
    description: 'Specialized supply chain solutions for your industry.',
    keywords: ['sectors', 'supply chain', 'industry solutions']
  },
  {
    path: '/contact',
    element: <ContactPage />,
    title: 'Contact Us - EasyBuy General Trading',
    description: 'Get in touch with EasyBuy General Trading for your global trading and supply chain management needs.',
    keywords: ['contact', 'get in touch', 'supply chain consultation']
  },
  {
    path: '/nashwan',
    element: <VisitingCardPage contactInfo={nashwanData} theme={easyBuyTheme} />,
    title: 'Nashwan - EasyBuy General Trading',
    description: 'Digital Business Card',
    keywords: ['vcard', 'contact']
  },
  {
    path: '/sanood',
    element: <VisitingCardPage contactInfo={sanoodData} theme={infiniteOriginTheme} />,
    title: 'Sanood - EasyBuy General Trading',
    description: 'Digital Business Card',
    keywords: ['vcard', 'contact']
  },
  {
    path: '*',
    element: <NotFoundPage />,
    title: 'Page Not Found - EasyBuy General Trading',
    description: 'The page you are looking for could not be found.'
  }
];

// Convert to RouteObject format for React Router
export const routeObjects: RouteObject[] = routes.map(({ title: _title, description: _description, keywords: _keywords, protected: _isProtected, ...route }) => route);